var _regeneratorRuntime = require("/Volumes/Github-Projects/translation-helps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/Github-Projects/translation-helps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck2 = require("/Volumes/Github-Projects/translation-helps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass2 = require("/Volumes/Github-Projects/translation-helps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("lodash/find"), require("axios"), require("lodash/omit"), require("lodash/merge"), require("lodash/isFunction"), require("lodash/isString"), require("lodash/map"), require("lodash/isEmpty"), require("lodash/size"));else if (typeof define === 'function' && define.amd) define(["lodash/find", "axios", "lodash/omit", "lodash/merge", "lodash/isFunction", "lodash/isString", "lodash/map", "lodash/isEmpty", "lodash/size"], factory);else if (typeof exports === 'object') exports["axiosCacheAdapter"] = factory(require("lodash/find"), require("axios"), require("lodash/omit"), require("lodash/merge"), require("lodash/isFunction"), require("lodash/isString"), require("lodash/map"), require("lodash/isEmpty"), require("lodash/size"));else root["axiosCacheAdapter"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(window, function (__WEBPACK_EXTERNAL_MODULE_lodash_find__, __WEBPACK_EXTERNAL_MODULE_axios__, __WEBPACK_EXTERNAL_MODULE_lodash_omit__, __WEBPACK_EXTERNAL_MODULE_lodash_merge__, __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__, __WEBPACK_EXTERNAL_MODULE_lodash_isString__, __WEBPACK_EXTERNAL_MODULE_lodash_map__, __WEBPACK_EXTERNAL_MODULE_lodash_isEmpty__, __WEBPACK_EXTERNAL_MODULE_lodash_size__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "./node_modules/@tusbar/cache-control/index.js":
      /*!*****************************************************!*\
        !*** ./node_modules/@tusbar/cache-control/index.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesTusbarCacheControlIndexJs(module, exports) {
        var HEADER_REGEXP = /([a-zA-Z][a-zA-Z_-]*)\s*(?:=(?:"([^"]*)"|([^ \t",;]*)))?/g;
        var STRINGS = {
          maxAge: 'max-age',
          sharedMaxAge: 's-maxage',
          maxStale: 'max-stale',
          minFresh: 'min-fresh',
          immutable: 'immutable',
          mustRevalidate: 'must-revalidate',
          noCache: 'no-cache',
          noStore: 'no-store',
          noTransform: 'no-transform',
          onlyIfCached: 'only-if-cached',
          private: 'private',
          proxyRevalidate: 'proxy-revalidate',
          public: 'public'
        };

        function parseBooleanOnly(value) {
          return value === null;
        }

        function parseDuration(value) {
          if (!value) {
            return null;
          }

          var duration = parseInt(value, 10);

          if (!Number.isFinite(duration) || duration < 0) {
            return null;
          }

          return duration;
        }

        var CacheControl =
        /*#__PURE__*/
        function () {
          "use strict";

          function CacheControl() {
            _classCallCheck2(this, CacheControl);

            this.maxAge = null;
            this.sharedMaxAge = null;
            this.maxStale = null;
            this.maxStaleDuration = null;
            this.minFresh = null;
            this.immutable = null;
            this.mustRevalidate = null;
            this.noCache = null;
            this.noStore = null;
            this.noTransform = null;
            this.onlyIfCached = null;
            this.private = null;
            this.proxyRevalidate = null;
            this.public = null;
          }

          _createClass2(CacheControl, [{
            key: "parse",
            value: function parse(header) {
              if (!header || header.length === 0) {
                return this;
              }

              var values = {};
              var matches = header.match(HEADER_REGEXP) || [];
              Array.prototype.forEach.call(matches, function (match) {
                var tokens = match.split('=', 2);

                var _tokens = _slicedToArray(tokens, 1),
                    key = _tokens[0];

                var value = null;

                if (tokens.length > 1) {
                  value = tokens[1].trim();
                }

                values[key.toLowerCase()] = value;
              });
              this.maxAge = parseDuration(values[STRINGS.maxAge]);
              this.sharedMaxAge = parseDuration(values[STRINGS.sharedMaxAge]);
              this.maxStale = parseBooleanOnly(values[STRINGS.maxStale]);
              this.maxStaleDuration = parseDuration(values[STRINGS.maxStale]);

              if (this.maxStaleDuration) {
                this.maxStale = true;
              }

              this.minFresh = parseDuration(values[STRINGS.minFresh]);
              this.immutable = parseBooleanOnly(values[STRINGS.immutable]);
              this.mustRevalidate = parseBooleanOnly(values[STRINGS.mustRevalidate]);
              this.noCache = parseBooleanOnly(values[STRINGS.noCache]);
              this.noStore = parseBooleanOnly(values[STRINGS.noStore]);
              this.noTransform = parseBooleanOnly(values[STRINGS.noTransform]);
              this.onlyIfCached = parseBooleanOnly(values[STRINGS.onlyIfCached]);
              this.private = parseBooleanOnly(values[STRINGS.private]);
              this.proxyRevalidate = parseBooleanOnly(values[STRINGS.proxyRevalidate]);
              this.public = parseBooleanOnly(values[STRINGS.public]);
              return this;
            }
          }, {
            key: "format",
            value: function format() {
              var tokens = [];

              if (this.maxAge) {
                tokens.push("".concat(STRINGS.maxAge, "=").concat(this.maxAge));
              }

              if (this.sharedMaxAge) {
                tokens.push("".concat(STRINGS.sharedMaxAge, "=").concat(this.sharedMaxAge));
              }

              if (this.maxStale) {
                if (this.maxStaleDuration) {
                  tokens.push("".concat(STRINGS.maxStale, "=").concat(this.maxStaleDuration));
                } else {
                  tokens.push(STRINGS.maxStale);
                }
              }

              if (this.minFresh) {
                tokens.push("".concat(STRINGS.minFresh, "=").concat(this.minFresh));
              }

              if (this.immutable) {
                tokens.push(STRINGS.immutable);
              }

              if (this.mustRevalidate) {
                tokens.push(STRINGS.mustRevalidate);
              }

              if (this.noCache) {
                tokens.push(STRINGS.noCache);
              }

              if (this.noStore) {
                tokens.push(STRINGS.noStore);
              }

              if (this.noTransform) {
                tokens.push(STRINGS.noTransform);
              }

              if (this.onlyIfCached) {
                tokens.push(STRINGS.onlyIfCached);
              }

              if (this.private) {
                tokens.push(STRINGS.private);
              }

              if (this.proxyRevalidate) {
                tokens.push(STRINGS.proxyRevalidate);
              }

              if (this.public) {
                tokens.push(STRINGS.public);
              }

              return tokens.join(', ');
            }
          }]);

          return CacheControl;
        }();

        function parse(header) {
          var cc = new CacheControl();
          return cc.parse(header);
        }

        function format(cc) {
          if (!(cc instanceof CacheControl)) {
            return CacheControl.prototype.format.call(cc);
          }

          return cc.format();
        }

        module.exports = {
          CacheControl: CacheControl,
          parse: parse,
          format: format
          /***/

        };
      },

      /***/
      "./node_modules/core-js/modules/_a-function.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_a-function.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_add-to-unscopables.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/_add-to-unscopables.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_addToUnscopablesJs(module, exports, __webpack_require__) {
        // 22.1.3.31 Array.prototype[@@unscopables]
        var UNSCOPABLES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('unscopables');

        var ArrayProto = Array.prototype;
        if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});

        module.exports = function (key) {
          ArrayProto[UNSCOPABLES][key] = true;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_an-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_an-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-includes.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_array-includes.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var toAbsoluteIndex = __webpack_require__(
        /*! ./_to-absolute-index */
        "./node_modules/core-js/modules/_to-absolute-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_cof.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_cof.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_core.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_core.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.5.7'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_ctx.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_ctx.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_defined.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_defined.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_descriptors.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_descriptors.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_dom-create.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_dom-create.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document; // typeof document.createElement is 'object' in old IE


        var is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_enum-bug-keys.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_export.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_export.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js");

        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
          var key, own, out, exp;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

            out = (own ? target : source)[key]; // bind timers to global for call from export context

            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

            if (target) redefine(target, key, out, type & $export.U); // export

            if (exports[key] != out) hide(exports, key, exp);
            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
          }
        };

        global.core = core; // type bitmap

        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library`

        module.exports = $export;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_fails.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_fails.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_flags.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_flags.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_flagsJs(module, exports, __webpack_require__) {
        "use strict"; // 21.2.5.3 get RegExp.prototype.flags

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        module.exports = function () {
          var that = anObject(this);
          var result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_global.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_global.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_has.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_has.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_hide.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_hide.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_html.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_html.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_htmlJs(module, exports, __webpack_require__) {
        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document;

        module.exports = document && document.documentElement;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_ie8-dom-define.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_iobject.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_iobject.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js"); // eslint-disable-next-line no-prototype-builtins


        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_is-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_is-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-create.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-create.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterCreateJs(module, exports, __webpack_require__) {
        "use strict";

        var create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js");

        var descriptor = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js");

        var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

        __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
          });
          setToStringTag(Constructor, NAME + ' Iterator');
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-define.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-define.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterDefineJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        var $iterCreate = __webpack_require__(
        /*! ./_iter-create */
        "./node_modules/core-js/modules/_iter-create.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "./node_modules/core-js/modules/_object-gpo.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator');

        var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

        var FF_ITERATOR = '@@iterator';
        var KEYS = 'keys';
        var VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);

          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];

            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };

              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }

            return function entries() {
              return new Constructor(this, kind);
            };
          };

          var TAG = NAME + ' Iterator';
          var DEF_VALUES = DEFAULT == VALUES;
          var VALUES_BUG = false;
          var proto = Base.prototype;
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
          var $default = $native || getMethod(DEFAULT);
          var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
          var methods, key, IteratorPrototype; // Fix native

          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

              if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;

            $default = function values() {
              return $native.call(this);
            };
          } // Define iterator


          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          } // Plug for library


          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;

          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-step.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-step.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterStepJs(module, exports) {
        module.exports = function (done, value) {
          return {
            value: value,
            done: !!done
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iterators.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iterators.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iteratorsJs(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_library.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_library.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_libraryJs(module, exports) {
        module.exports = false;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-create.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-create.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectCreateJs(module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var dPs = __webpack_require__(
        /*! ./_object-dps */
        "./node_modules/core-js/modules/_object-dps.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        var Empty = function Empty() {
          /* empty */
        };

        var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

        var _createDict = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('iframe');

          var i = enumBugKeys.length;
          var lt = '<';
          var gt = '>';
          var iframeDocument;
          iframe.style.display = 'none';

          __webpack_require__(
          /*! ./_html */
          "./node_modules/core-js/modules/_html.js").appendChild(iframe);

          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);

          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict = iframeDocument.F;

          while (i--) {
            delete _createDict[PROTOTYPE][enumBugKeys[i]];
          }

          return _createDict();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _createDict();

          return Properties === undefined ? result : dPs(result, Properties);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-dp.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dp.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/modules/_ie8-dom-define.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js");

        var dP = Object.defineProperty;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-dps.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dps.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpsJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties);
          var length = keys.length;
          var i = 0;
          var P;

          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }

          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gpo.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gpo.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGpoJs(module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        var ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectProto : null;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys-internal.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/modules/_array-includes.js")(false);

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/modules/_object-keys-internal.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_property-desc.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_property-desc.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_redefine.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_redefine.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_redefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var SRC = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js")('src');

        var TO_STRING = 'toString';
        var $toString = Function[TO_STRING];
        var TPL = ('' + $toString).split(TO_STRING);

        __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
          return $toString.call(it);
        };

        (module.exports = function (O, key, val, safe) {
          var isFunction = typeof val == 'function';
          if (isFunction) has(val, 'name') || hide(val, 'name', key);
          if (O[key] === val) return;
          if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

          if (O === global) {
            O[key] = val;
          } else if (!safe) {
            delete O[key];
            hide(O, key, val);
          } else if (O[key]) {
            O[key] = val;
          } else {
            hide(O, key, val);
          } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

        })(Function.prototype, TO_STRING, function toString() {
          return typeof this == 'function' && this[SRC] || $toString.call(this);
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_set-to-string-tag.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_set-to-string-tag.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setToStringTagJs(module, exports, __webpack_require__) {
        var def = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
            configurable: true,
            value: tag
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared-key.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_shared-key.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('keys');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_shared.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedJs(module, exports, __webpack_require__) {
        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});
        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: core.version,
          mode: __webpack_require__(
          /*! ./_library */
          "./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
          copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_to-absolute-index.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_to-absolute-index.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toAbsoluteIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var max = Math.max;
        var min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-integer.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-integer.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-iobject.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-iobject.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/modules/_iobject.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-length.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-length.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toObjectJs(module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return Object(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-primitive.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/modules/_to-primitive.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_uid.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_uid.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_uidJs(module, exports) {
        var id = 0;
        var px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_wks.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_wks.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksJs(module, exports, __webpack_require__) {
        var store = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('wks');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        var Symbol = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").Symbol;

        var USE_SYMBOL = typeof Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.array.iterator.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.iterator.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var addToUnscopables = __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js");

        var step = __webpack_require__(
        /*! ./_iter-step */
        "./node_modules/core-js/modules/_iter-step.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"); // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()


        module.exports = __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target

          this._i = 0; // next index

          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;

          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }

          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

        Iterators.Arguments = Iterators.Array;
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.date.to-string.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.date.to-string.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6DateToStringJs(module, exports, __webpack_require__) {
        var DateProto = Date.prototype;
        var INVALID_DATE = 'Invalid Date';
        var TO_STRING = 'toString';
        var $toString = DateProto[TO_STRING];
        var getTime = DateProto.getTime;

        if (new Date(NaN) + '' != INVALID_DATE) {
          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(DateProto, TO_STRING, function toString() {
            var value = getTime.call(this); // eslint-disable-next-line no-self-compare

            return value === value ? $toString.call(this) : INVALID_DATE;
          });
        }
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.object.define-property.js":
      /*!********************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.object.define-property.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ObjectDefinePropertyJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js"), 'Object', {
          defineProperty: __webpack_require__(
          /*! ./_object-dp */
          "./node_modules/core-js/modules/_object-dp.js").f
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.flags.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.flags.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpFlagsJs(module, exports, __webpack_require__) {
        // 21.2.5.3 get RegExp.prototype.flags()
        if (__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
          configurable: true,
          get: __webpack_require__(
          /*! ./_flags */
          "./node_modules/core-js/modules/_flags.js")
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.to-string.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.to-string.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpToStringJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! ./es6.regexp.flags */
        "./node_modules/core-js/modules/es6.regexp.flags.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var $flags = __webpack_require__(
        /*! ./_flags */
        "./node_modules/core-js/modules/_flags.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js");

        var TO_STRING = 'toString';
        var $toString = /./[TO_STRING];

        var define = function define(fn) {
          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
        }; // 21.2.5.14 RegExp.prototype.toString()


        if (__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return $toString.call({
            source: 'a',
            flags: 'b'
          }) != '/a/b';
        })) {
          define(function toString() {
            var R = anObject(this);
            return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
          }); // FF44- RegExp#toString has a wrong name
        } else if ($toString.name != TO_STRING) {
          define(function toString() {
            return $toString.call(this);
          });
        }
        /***/

      },

      /***/
      "./node_modules/regenerator-runtime/runtime.js":
      /*!*****************************************************!*\
        !*** ./node_modules/regenerator-runtime/runtime.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegeneratorRuntimeRuntimeJs(module, exports) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        !function (global) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          var inModule = typeof module === "object";
          var runtime = global.regeneratorRuntime;

          if (runtime) {
            if (inModule) {
              // If regeneratorRuntime is defined globally and we're in a module,
              // make the exports object identical to regeneratorRuntime.
              module.exports = runtime;
            } // Don't bother evaluating the rest of this file if the runtime was
            // already defined globally.


            return;
          } // Define the runtime globally (as expected by generated code) as either
          // module.exports (if we're in a module) or a new, empty object.


          runtime = global.regeneratorRuntime = inModule ? module.exports : {};

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          runtime.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          runtime.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          runtime.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration. If the Promise is rejected, however, the
                  // result for this iteration will be rejected with the same
                  // reason. Note that rejections of yielded Promises are not
                  // thrown back into the generator function, as is the case
                  // when an awaited Promise is rejected. This difference in
                  // behavior between yield and await is important, because it
                  // allows the consumer to decide what to do with the yielded
                  // rejection (swallow it and continue, manually .throw it back
                  // into the generator, abandon iteration, whatever). With
                  // await, by contrast, there is no opportunity to examine the
                  // rejection reason outside the generator function, so the
                  // only option is to throw it from the await expression, and
                  // let the generator function handle the exception.
                  result.value = unwrapped;
                  resolve(result);
                }, reject);
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          runtime.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                if (delegate.iterator.return) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          runtime.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          runtime.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          };
        }( // In sloppy mode, unbound `this` refers to the global object, fallback to
        // Function constructor if we're in global strict mode. That is sadly a form
        // of indirect eval which violates Content Security Policy.
        function () {
          return this;
        }() || Function("return this")());
        /***/
      },

      /***/
      "./src/cache.js":
      /*!**********************!*\
        !*** ./src/cache.js ***!
        \**********************/

      /*! exports provided: read, write, key, invalidate, serializeQuery, default */

      /***/
      function srcCacheJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "read", function () {
          return read;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "write", function () {
          return write;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "key", function () {
          return key;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "invalidate", function () {
          return invalidate;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "serializeQuery", function () {
          return serializeQuery;
        });
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_date_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.date.to-string */
        "./node_modules/core-js/modules/es6.date.to-string.js");
        /* harmony import */


        var core_js_modules_es6_date_to_string__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_date_to_string__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var lodash_isString__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! lodash/isString */
        "lodash/isString");
        /* harmony import */


        var lodash_isString__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var lodash_isFunction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! lodash/isFunction */
        "lodash/isFunction");
        /* harmony import */


        var lodash_isFunction__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var lodash_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! lodash/map */
        "lodash/map");
        /* harmony import */


        var lodash_map__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _serialize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./serialize */
        "./src/serialize.js");

        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        function write(_x, _x2, _x3) {
          return _write.apply(this, arguments);
        }

        function _write() {
          _write = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee(config, req, res) {
            var entry;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    entry = {
                      expires: config.expires,
                      data: Object(_serialize__WEBPACK_IMPORTED_MODULE_6__["default"])(config, req, res)
                    };
                    _context.next = 4;
                    return config.store.setItem(config.uuid, entry);

                  case 4:
                    _context.next = 19;
                    break;

                  case 6:
                    _context.prev = 6;
                    _context.t0 = _context["catch"](0);
                    config.debug('Could not store response', _context.t0);

                    if (!config.clearOnError) {
                      _context.next = 18;
                      break;
                    }

                    _context.prev = 10;
                    _context.next = 13;
                    return config.store.clear();

                  case 13:
                    _context.next = 18;
                    break;

                  case 15:
                    _context.prev = 15;
                    _context.t1 = _context["catch"](10);
                    config.debug('Could not clear store', _context.t1);

                  case 18:
                    return _context.abrupt("return", false);

                  case 19:
                    return _context.abrupt("return", true);

                  case 20:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[0, 6], [10, 15]]);
          }));
          return _write.apply(this, arguments);
        }

        function read(_x4, _x5) {
          return _read.apply(this, arguments);
        }

        function _read() {
          _read = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2(config, req) {
            var uuid, ignoreCache, entry, error, expires, data, offline, _error;

            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    uuid = config.uuid, ignoreCache = config.ignoreCache;
                    _context2.next = 3;
                    return config.store.getItem(uuid);

                  case 3:
                    entry = _context2.sent;

                    if (!(ignoreCache || !entry || !entry.data)) {
                      _context2.next = 10;
                      break;
                    }

                    config.debug('cache-miss', req.url);
                    error = new Error();
                    error.reason = 'cache-miss';
                    error.message = 'Entry not found from cache';
                    throw error;

                  case 10:
                    expires = entry.expires, data = entry.data; // Do not check for stale cache if offline on client-side

                    offline = typeof navigator !== 'undefined' && 'onLine' in navigator && !navigator.onLine;

                    if (!(!offline && !config.acceptStale && expires !== 0 && expires < Date.now())) {
                      _context2.next = 18;
                      break;
                    }

                    config.debug('cache-stale', req.url);
                    _error = new Error();
                    _error.reason = 'cache-stale';
                    _error.message = 'Entry is stale';
                    throw _error;

                  case 18:
                    config.debug(config.acceptStale ? 'cache-hit-stale' : 'cache-hit', req.url);
                    return _context2.abrupt("return", data);

                  case 20:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));
          return _read.apply(this, arguments);
        }

        function key(config) {
          if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_4___default()(config.key)) return config.key;
          var cacheKey;
          if (lodash_isString__WEBPACK_IMPORTED_MODULE_3___default()(config.key)) cacheKey = function cacheKey(req) {
            return "".concat(config.key, "/").concat(req.url).concat(serializeQuery(req));
          };else cacheKey = function cacheKey(req) {
            return req.url + serializeQuery(req);
          };
          return cacheKey;
        }

        function defaultInvalidate(_x6, _x7) {
          return _defaultInvalidate.apply(this, arguments);
        }

        function _defaultInvalidate() {
          _defaultInvalidate = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3(cfg, req) {
            var method;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    method = req.method.toLowerCase();

                    if (!(method !== 'get')) {
                      _context3.next = 4;
                      break;
                    }

                    _context3.next = 4;
                    return cfg.store.removeItem(cfg.uuid);

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));
          return _defaultInvalidate.apply(this, arguments);
        }

        function invalidate() {
          var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_4___default()(config.invalidate)) return config.invalidate;
          return defaultInvalidate;
        }

        function serializeQuery(req) {
          if (!req.params) return ''; // Probably server-side, just stringify the object

          if (typeof URLSearchParams === 'undefined') return JSON.stringify(req.params);
          var params = req.params;
          var isInstanceOfURLSearchParams = req.params instanceof URLSearchParams; // Convert to an instance of URLSearchParams so it get serialized the same way

          if (!isInstanceOfURLSearchParams) {
            params = new URLSearchParams(); // Using lodash/map even though we don't listen to output so we don't have to bundle lodash/forEach

            lodash_map__WEBPACK_IMPORTED_MODULE_5___default()(req.params, function (value, key) {
              return params.append(key, value);
            });
          }

          return "?".concat(params.toString());
        }
        /* harmony default export */


        __webpack_exports__["default"] = {
          read: read,
          write: write,
          key: key,
          invalidate: invalidate,
          serializeQuery: serializeQuery
        };
        /***/
      },

      /***/
      "./src/config.js":
      /*!***********************!*\
        !*** ./src/config.js ***!
        \***********************/

      /*! exports provided: defaults, makeConfig, mergeRequestConfig, default */

      /***/
      function srcConfigJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "defaults", function () {
          return defaults;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeConfig", function () {
          return makeConfig;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "mergeRequestConfig", function () {
          return mergeRequestConfig;
        });
        /* harmony import */


        var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! axios */
        "axios");
        /* harmony import */


        var axios__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var lodash_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! lodash/merge */
        "lodash/merge");
        /* harmony import */


        var lodash_merge__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var lodash_omit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! lodash/omit */
        "lodash/omit");
        /* harmony import */


        var lodash_omit__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _memory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./memory */
        "./src/memory.js");
        /* harmony import */


        var _cache__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./cache */
        "./src/cache.js");

        var noop = function noop() {};

        var debug = function debug() {
          var _console;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return (_console = console).log.apply(_console, ['[axios-cache-adapter]'].concat(args));
        };

        var defaults = {
          // Default settings when solely creating the cache adapter with setupCache.
          cache: {
            maxAge: 0,
            limit: false,
            store: null,
            key: null,
            invalidate: null,
            exclude: {
              paths: [],
              query: true,
              filter: null
            },
            adapter: axios__WEBPACK_IMPORTED_MODULE_0___default.a.defaults.adapter,
            clearOnStale: true,
            clearOnError: true,
            readOnError: false,
            readHeaders: false,
            debug: false,
            ignoreCache: false
          },
          // Additional defaults when creating the axios instance with the cache adapter.
          axios: {
            cache: {
              maxAge: 15 * 60 * 1000
            } // List of disallowed in the per-request config.

          }
        };
        var disallowedPerRequestKeys = ['limit', 'store', 'adapter', 'uuid', 'acceptStale'];
        /**
         * Make a global config object.
         *
         * @param {Object} [override={}] Optional config override.
         * @return {Object}
         */

        var makeConfig = function makeConfig() {
          var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var config = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, defaults.cache, override); // Create a cache key method

          config.key = Object(_cache__WEBPACK_IMPORTED_MODULE_4__["key"])(config);
          config.invalidate = Object(_cache__WEBPACK_IMPORTED_MODULE_4__["invalidate"])(config); // If debug mode is on, create a simple logger method

          if (config.debug !== false) {
            config.debug = typeof config.debug === 'function' ? config.debug : debug;
          } else {
            config.debug = noop;
          } // Create an in memory store if none was given


          if (!config.store) config.store = new _memory__WEBPACK_IMPORTED_MODULE_3__["default"]();
          config.debug('Global cache config', config);
          return config;
        };
        /**
         * Merge the per-request config in another config.
         *
         * This method exists because not all keys should be allowed as it
         * may lead to unexpected behaviours. For instance, setting another
         * store or adapter per request is wrong, instead another instance
         * axios, or the adapter, should be used.
         *
         * @param {Object} config Config object.
         * @param {Object} req    The current axios request
         * @return {Object}
         */


        var mergeRequestConfig = function mergeRequestConfig(config, req) {
          var requestConfig = req.cache;
          var mergedConfig = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, config, lodash_omit__WEBPACK_IMPORTED_MODULE_2___default()(requestConfig, disallowedPerRequestKeys));

          if (mergedConfig.debug === true) {
            mergedConfig.debug = debug;
          } // Generate request UUID


          mergedConfig.uuid = config.key(req);
          config.debug("Request config for ".concat(req.url), mergedConfig);
          return mergedConfig;
        };
        /* harmony default export */


        __webpack_exports__["default"] = {
          defaults: defaults,
          makeConfig: makeConfig,
          mergeRequestConfig: mergeRequestConfig
        };
        /***/
      },

      /***/
      "./src/exclude.js":
      /*!************************!*\
        !*** ./src/exclude.js ***!
        \************************/

      /*! exports provided: default */

      /***/
      function srcExcludeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var lodash_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! lodash/find */
        "lodash/find");
        /* harmony import */


        var lodash_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! lodash/isEmpty */
        "lodash/isEmpty");
        /* harmony import */


        var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);

        function exclude() {
          var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var req = arguments.length > 1 ? arguments[1] : undefined;
          var _config$exclude = config.exclude,
              exclude = _config$exclude === void 0 ? {} : _config$exclude,
              debug = config.debug;

          if (typeof exclude.filter === 'function' && exclude.filter(req)) {
            debug("Excluding request by filter ".concat(req.url));
            return true;
          } // do not cache request with query


          var hasQueryParams = req.url.match(/\?.*$/) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(req.params) || typeof URLSearchParams !== 'undefined' && req.params instanceof URLSearchParams;

          if (exclude.query && hasQueryParams) {
            debug("Excluding request by query ".concat(req.url));
            return true;
          }

          var paths = exclude.paths || [];
          var found = lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(paths, function (regexp) {
            return req.url.match(regexp);
          });

          if (found) {
            debug("Excluding request by url match ".concat(req.url));
            return true;
          }

          return false;
        }
        /* harmony default export */


        __webpack_exports__["default"] = exclude;
        /***/
      },

      /***/
      "./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/

      /*! exports provided: setup, setupCache, serializeQuery, default */

      /***/
      function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "setup", function () {
          return setup;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "setupCache", function () {
          return setupCache;
        });
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! axios */
        "axios");
        /* harmony import */


        var axios__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var lodash_omit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! lodash/omit */
        "lodash/omit");
        /* harmony import */


        var lodash_omit__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var lodash_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! lodash/merge */
        "lodash/merge");
        /* harmony import */


        var lodash_merge__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var lodash_isFunction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! lodash/isFunction */
        "lodash/isFunction");
        /* harmony import */


        var lodash_isFunction__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _request__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./request */
        "./src/request.js");
        /* harmony import */


        var _cache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./cache */
        "./src/cache.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "serializeQuery", function () {
          return _cache__WEBPACK_IMPORTED_MODULE_6__["serializeQuery"];
        });
        /* harmony import */


        var _config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./config */
        "./src/config.js");

        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }
        /**
         * Configure cache adapter
         *
         * @param   {object} [config={}] Cache adapter options
         * @returns {object} Object containing cache `adapter` and `store`
         */


        function setupCache() {
          var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Extend default configuration

          config = Object(_config__WEBPACK_IMPORTED_MODULE_7__["makeConfig"])(config); // Axios adapter. Receives the axios request configuration as only parameter

          function adapter(_x) {
            return _adapter.apply(this, arguments);
          } // Return adapter and store instance


          function _adapter() {
            _adapter = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(req) {
              var reqConfig, res, next, networkError, readOnError;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      // Merge the per-request config with the instance config.
                      reqConfig = Object(_config__WEBPACK_IMPORTED_MODULE_7__["mergeRequestConfig"])(config, req); // Execute request against local cache

                      _context.next = 3;
                      return Object(_request__WEBPACK_IMPORTED_MODULE_5__["default"])(reqConfig, req);

                    case 3:
                      res = _context.sent;
                      next = res.next; // Response is not function, something was in cache, return it

                      if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_4___default()(next)) {
                        _context.next = 7;
                        break;
                      }

                      return _context.abrupt("return", next);

                    case 7:
                      _context.prev = 7;
                      _context.next = 10;
                      return reqConfig.adapter(req);

                    case 10:
                      res = _context.sent;
                      _context.next = 16;
                      break;

                    case 13:
                      _context.prev = 13;
                      _context.t0 = _context["catch"](7);
                      networkError = _context.t0;

                    case 16:
                      if (!networkError) {
                        _context.next = 31;
                        break;
                      } // Check if we should attempt reading stale cache data


                      readOnError = lodash_isFunction__WEBPACK_IMPORTED_MODULE_4___default()(reqConfig.readOnError) ? reqConfig.readOnError(networkError, req) : reqConfig.readOnError;

                      if (!readOnError) {
                        _context.next = 30;
                        break;
                      }

                      _context.prev = 19; // Force cache tu return stale data

                      reqConfig.acceptStale = true; // Try to read from cache again

                      _context.next = 23;
                      return Object(_request__WEBPACK_IMPORTED_MODULE_5__["default"])(reqConfig, req);

                    case 23:
                      res = _context.sent; // Signal that data is from stale cache

                      res.next.request.stale = true; // No need to check if `next` is a function just return cache data

                      return _context.abrupt("return", res.next);

                    case 28:
                      _context.prev = 28;
                      _context.t1 = _context["catch"](19);

                    case 30:
                      throw networkError;

                    case 31:
                      return _context.abrupt("return", next(res));

                    case 32:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this, [[7, 13], [19, 28]]);
            }));
            return _adapter.apply(this, arguments);
          }

          return {
            adapter: adapter,
            config: config,
            store: config.store
          };
        } // ---------------------
        // Easy API Setup
        // ---------------------

        /**
         * Setup an axios instance with the cache adapter pre-configured
         *
         * @param {object} [options={}] Axios and cache adapter options
         * @returns {object} Instance of Axios
         */


        function setup() {
          var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          config = lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()({}, _config__WEBPACK_IMPORTED_MODULE_7__["defaults"].axios, config);
          var cache = setupCache(config.cache);
          var axiosConfig = lodash_omit__WEBPACK_IMPORTED_MODULE_2___default()(config, ['cache']);
          var api = axios__WEBPACK_IMPORTED_MODULE_1___default.a.create(lodash_merge__WEBPACK_IMPORTED_MODULE_3___default()({}, axiosConfig, {
            adapter: cache.adapter
          }));
          api.cache = cache.store;
          return api;
        }
        /* harmony default export */


        __webpack_exports__["default"] = {
          setup: setup,
          setupCache: setupCache,
          serializeQuery: _cache__WEBPACK_IMPORTED_MODULE_6__["serializeQuery"]
        };
        /***/
      },

      /***/
      "./src/limit.js":
      /*!**********************!*\
        !*** ./src/limit.js ***!
        \**********************/

      /*! exports provided: default */

      /***/
      function srcLimitJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);

        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        function limit(_x) {
          return _limit.apply(this, arguments);
        }

        function _limit() {
          _limit = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee(config) {
            var length, firstItem;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return config.store.length();

                  case 2:
                    length = _context.sent;

                    if (!(length < config.limit)) {
                      _context.next = 5;
                      break;
                    }

                    return _context.abrupt("return");

                  case 5:
                    config.debug("Current store size: ".concat(length));
                    _context.next = 8;
                    return config.store.iterate(function (value, key) {
                      if (!firstItem) firstItem = {
                        value: value,
                        key: key
                      };
                      if (value.expires < firstItem.value.expires) firstItem = {
                        value: value,
                        key: key
                      };
                    });

                  case 8:
                    if (!firstItem) {
                      _context.next = 12;
                      break;
                    }

                    config.debug("Removing item: ".concat(firstItem.key));
                    _context.next = 12;
                    return config.store.removeItem(firstItem.key);

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
          return _limit.apply(this, arguments);
        }
        /* harmony default export */


        __webpack_exports__["default"] = limit;
        /***/
      },

      /***/
      "./src/memory.js":
      /*!***********************!*\
        !*** ./src/memory.js ***!
        \***********************/

      /*! exports provided: default */

      /***/
      function srcMemoryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_define_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.define-property */
        "./node_modules/core-js/modules/es6.object.define-property.js");
        /* harmony import */


        var core_js_modules_es6_object_define_property__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_define_property__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var lodash_size__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! lodash/size */
        "lodash/size");
        /* harmony import */


        var lodash_size__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_size__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var lodash_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! lodash/map */
        "lodash/map");
        /* harmony import */


        var lodash_map__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_4__);

        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        var MemoryStore =
        /*#__PURE__*/
        function () {
          function MemoryStore() {
            _classCallCheck(this, MemoryStore);

            this.store = {};
          }

          _createClass(MemoryStore, [{
            key: "getItem",
            value: function () {
              var _getItem = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(key) {
                var item;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        item = this.store[key] || null;
                        return _context.abrupt("return", JSON.parse(item));

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              return function getItem(_x) {
                return _getItem.apply(this, arguments);
              };
            }()
          }, {
            key: "setItem",
            value: function () {
              var _setItem = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee2(key, value) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        this.store[key] = JSON.stringify(value);
                        return _context2.abrupt("return", value);

                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              return function setItem(_x2, _x3) {
                return _setItem.apply(this, arguments);
              };
            }()
          }, {
            key: "removeItem",
            value: function () {
              var _removeItem = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3(key) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        delete this.store[key];

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              return function removeItem(_x4) {
                return _removeItem.apply(this, arguments);
              };
            }()
          }, {
            key: "clear",
            value: function () {
              var _clear = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        this.store = {};

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, this);
              }));

              return function clear() {
                return _clear.apply(this, arguments);
              };
            }()
          }, {
            key: "length",
            value: function () {
              var _length = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee5() {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", lodash_size__WEBPACK_IMPORTED_MODULE_3___default()(this.store));

                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, this);
              }));

              return function length() {
                return _length.apply(this, arguments);
              };
            }()
          }, {
            key: "iterate",
            value: function iterate(fn) {
              return Promise.all(lodash_map__WEBPACK_IMPORTED_MODULE_4___default()(this.store, function (value, key) {
                return fn(value, key);
              }));
            }
          }]);

          return MemoryStore;
        }();
        /* harmony default export */


        __webpack_exports__["default"] = MemoryStore;
        /***/
      },

      /***/
      "./src/request.js":
      /*!************************!*\
        !*** ./src/request.js ***!
        \************************/

      /*! exports provided: default */

      /***/
      function srcRequestJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _response__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./response */
        "./src/response.js");
        /* harmony import */


        var _exclude__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./exclude */
        "./src/exclude.js");
        /* harmony import */


        var _cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./cache */
        "./src/cache.js");

        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        function request(_x, _x2) {
          return _request.apply(this, arguments);
        }

        function _request() {
          _request = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee(config, req) {
            var next, method, res, excludeFromCache;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    excludeFromCache = function _ref() {
                      config.excludeFromCache = true;
                      return {
                        config: config,
                        next: next
                      };
                    };

                    config.debug('uuid', config.uuid);

                    next = function next() {
                      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                      }

                      return _response__WEBPACK_IMPORTED_MODULE_1__["default"].apply(void 0, [config, req].concat(args));
                    }; // run invalidate function to check if any cache items need to be invalidated.


                    _context.next = 5;
                    return config.invalidate(config, req);

                  case 5:
                    if (!Object(_exclude__WEBPACK_IMPORTED_MODULE_2__["default"])(config, req)) {
                      _context.next = 7;
                      break;
                    }

                    return _context.abrupt("return", excludeFromCache());

                  case 7:
                    method = req.method.toLowerCase();

                    if (!(method === 'head' || method !== 'get')) {
                      _context.next = 10;
                      break;
                    }

                    return _context.abrupt("return", excludeFromCache());

                  case 10:
                    _context.prev = 10;
                    _context.next = 13;
                    return Object(_cache__WEBPACK_IMPORTED_MODULE_3__["read"])(config, req);

                  case 13:
                    res = _context.sent;
                    res.config = req;
                    res.request = {
                      fromCache: true
                    };
                    return _context.abrupt("return", {
                      config: config,
                      next: res
                    });

                  case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](10);

                    if (!(config.clearOnStale && _context.t0.reason === 'cache-stale')) {
                      _context.next = 24;
                      break;
                    }

                    _context.next = 24;
                    return config.store.removeItem(config.uuid);

                  case 24:
                    return _context.abrupt("return", {
                      config: config,
                      next: next
                    });

                  case 25:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[10, 19]]);
          }));
          return _request.apply(this, arguments);
        }
        /* harmony default export */


        __webpack_exports__["default"] = request;
        /***/
      },

      /***/
      "./src/response.js":
      /*!*************************!*\
        !*** ./src/response.js ***!
        \*************************/

      /*! exports provided: default */

      /***/
      function srcResponseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _limit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./limit */
        "./src/limit.js");
        /* harmony import */


        var _cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./cache */
        "./src/cache.js");
        /* harmony import */


        var _tusbar_cache_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @tusbar/cache-control */
        "./node_modules/@tusbar/cache-control/index.js");
        /* harmony import */


        var _tusbar_cache_control__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_tusbar_cache_control__WEBPACK_IMPORTED_MODULE_3__);

        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        function response(_x, _x2, _x3) {
          return _response.apply(this, arguments);
        }

        function _response() {
          _response = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee(config, req, res) {
            var _res$request, request, _res$headers, headers, cacheControl;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _res$request = res.request, request = _res$request === void 0 ? {} : _res$request, _res$headers = res.headers, headers = _res$headers === void 0 ? {} : _res$headers; // exclude binary response from cache

                    if (!(['arraybuffer', 'blob'].indexOf(request.responseType) > -1)) {
                      _context.next = 3;
                      break;
                    }

                    return _context.abrupt("return", res);

                  case 3:
                    cacheControl = {}; // Should we try to determine request cache expiration from headers or not

                    if (config.readHeaders) {
                      if (headers['cache-control']) {
                        // Try parsing `cache-control` header from response
                        cacheControl = Object(_tusbar_cache_control__WEBPACK_IMPORTED_MODULE_3__["parse"])(headers['cache-control']); // Force cache exlcusion for `cache-control: no-cache` and `cache-control: no-store`

                        if (cacheControl.noCache || cacheControl.noStore) {
                          config.excludeFromCache = true;
                        }
                      } else if (headers.expires) {
                        // Else try reading `expires` header
                        config.expires = new Date(headers.expires).getTime();
                      }
                    }

                    if (config.excludeFromCache) {
                      _context.next = 15;
                      break;
                    }

                    if (cacheControl.maxAge) {
                      // Use `cache-control` header `max-age` value and convert to milliseconds
                      config.expires = Date.now() + cacheControl.maxAge * 1000;
                    } else if (!config.readHeaders) {
                      // Use fixed `maxAge` defined in the global or per-request config
                      config.expires = config.maxAge === 0 ? 0 : Date.now() + config.maxAge;
                    } // Check if a cache limit has been configured


                    if (!config.limit) {
                      _context.next = 11;
                      break;
                    }

                    config.debug("Detected limit: ".concat(config.limit));
                    _context.next = 11;
                    return Object(_limit__WEBPACK_IMPORTED_MODULE_1__["default"])(config);

                  case 11:
                    _context.next = 13;
                    return Object(_cache__WEBPACK_IMPORTED_MODULE_2__["write"])(config, req, res);

                  case 13:
                    _context.next = 16;
                    break;

                  case 15:
                    // Mark request as excluded from cache
                    res.request.excludedFromCache = true;

                  case 16:
                    return _context.abrupt("return", res);

                  case 17:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
          return _response.apply(this, arguments);
        }
        /* harmony default export */


        __webpack_exports__["default"] = response;
        /***/
      },

      /***/
      "./src/serialize.js":
      /*!**************************!*\
        !*** ./src/serialize.js ***!
        \**************************/

      /*! exports provided: default */

      /***/
      function srcSerializeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! lodash/omit */
        "lodash/omit");
        /* harmony import */


        var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);

        function serialize(config, req, res) {
          if (res.data) {
            // FIXME: May be useless as localForage and axios already parse automatically
            try {
              res.data = JSON.parse(res.data);
            } catch (err) {
              config.debug('Could not parse data as JSON', err);
            }
          }

          return lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(res, ['request', 'config']);
        }
        /* harmony default export */


        __webpack_exports__["default"] = serialize;
        /***/
      },

      /***/
      0:
      /*!****************************!*\
        !*** multi ./src/index.js ***!
        \****************************/

      /*! no static exports found */

      /***/
      function _(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./src/index.js */
        "./src/index.js");
        /***/
      },

      /***/
      "axios":
      /*!*************************************************************************************!*\
        !*** external {"umd":"axios","amd":"axios","commonjs":"axios","commonjs2":"axios"} ***!
        \*************************************************************************************/

      /*! no static exports found */

      /***/
      function axios(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_axios__;
        /***/
      },

      /***/
      "lodash/find":
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/find","amd":"lodash/find","commonjs":"lodash/find","commonjs2":"lodash/find"} ***!
        \*************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashFind(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_find__;
        /***/
      },

      /***/
      "lodash/isEmpty":
      /*!*************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isEmpty","amd":"lodash/isEmpty","commonjs":"lodash/isEmpty","commonjs2":"lodash/isEmpty"} ***!
        \*************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashIsEmpty(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isEmpty__;
        /***/
      },

      /***/
      "lodash/isFunction":
      /*!*************************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isFunction","amd":"lodash/isFunction","commonjs":"lodash/isFunction","commonjs2":"lodash/isFunction"} ***!
        \*************************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashIsFunction(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__;
        /***/
      },

      /***/
      "lodash/isString":
      /*!*****************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isString","amd":"lodash/isString","commonjs":"lodash/isString","commonjs2":"lodash/isString"} ***!
        \*****************************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashIsString(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isString__;
        /***/
      },

      /***/
      "lodash/map":
      /*!*********************************************************************************************************!*\
        !*** external {"umd":"lodash/map","amd":"lodash/map","commonjs":"lodash/map","commonjs2":"lodash/map"} ***!
        \*********************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashMap(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_map__;
        /***/
      },

      /***/
      "lodash/merge":
      /*!*****************************************************************************************************************!*\
        !*** external {"umd":"lodash/merge","amd":"lodash/merge","commonjs":"lodash/merge","commonjs2":"lodash/merge"} ***!
        \*****************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashMerge(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_merge__;
        /***/
      },

      /***/
      "lodash/omit":
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/omit","amd":"lodash/omit","commonjs":"lodash/omit","commonjs2":"lodash/omit"} ***!
        \*************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashOmit(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_omit__;
        /***/
      },

      /***/
      "lodash/size":
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/size","amd":"lodash/size","commonjs":"lodash/size","commonjs2":"lodash/size"} ***!
        \*************************************************************************************************************/

      /*! no static exports found */

      /***/
      function lodashSize(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_size__;
        /***/
      }
      /******/

    })
  );
});